export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./bk-frame.vue?vue&type=template&id=f4bfef82"


//////////////////
// WEBPACK FOOTER
// ./_common/components/bk-frame.vue?vue&type=template&id=f4bfef82
// module id = 0vcV
// module chunks = 37